import { useEffect, useMemo, useState } from 'react';
import PublicLayout from '@/components/public/PublicLayout';
import { AttractionCard } from '@/components/public/AttractionsPreview';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { publicApi } from '@/lib/api';
import { motion } from 'framer-motion';
import { fadeUp, stagger } from '@/lib/motion';
import { Particles } from '@/components/public/Particles';
import { ATTRACTION_CATEGORIES } from '@/lib/data';

const CATS = [
    { key: 'all', label: 'Todas' },
    ...ATTRACTION_CATEGORIES,
];

export default function AtraccionesPage() {
    const [items, setItems] = useState([]);
    const [cat, setCat] = useState('all');
    useEffect(() => { publicApi.getAttractions().then(setItems).catch(() => {}); }, []);
    const visible = useMemo(() => (cat === 'all' ? items : items.filter((a) => a.category === cat)), [items, cat]);
    return (
        <PublicLayout>
            <section className="relative overflow-hidden bg-gradient-fun text-white py-16 sm:py-20 lg:py-24">
                <div className="absolute -top-20 -left-20 w-80 h-80 rounded-full bg-[hsl(var(--kche-yellow))]/30 blur-3xl" />
                <div className="absolute -bottom-20 -right-20 w-80 h-80 rounded-full bg-[hsl(var(--kche-cyan))]/30 blur-3xl" />
                <Particles count={14} />
                <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <p className="text-sm font-bold font-display text-[hsl(var(--kche-yellow))] uppercase tracking-wider">Atracciones</p>
                    <h1 className="mt-1 text-4xl sm:text-5xl lg:text-6xl font-display font-bold leading-tight">Atracciones Kche <span className="text-[hsl(var(--kche-yellow))]">Diversiones</span></h1>
                    <p className="mt-4 text-white/95 max-w-2xl text-lg">Descubre nuestras experiencias por categoría. Reserva online en pocos clics.</p>
                </div>
            </section>
            <section className="bg-background py-12">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <Tabs value={cat} onValueChange={setCat}>
                        <TabsList className="flex flex-wrap gap-1 h-auto p-1.5 bg-white border border-border rounded-2xl shadow-soft">
                            {CATS.map((c) => (
                                <TabsTrigger key={c.key} value={c.key} data-testid={`atracciones-tab-${c.key}`} className="data-[state=active]:bg-gradient-fun data-[state=active]:text-white data-[state=active]:shadow-pop rounded-xl px-4 py-2 text-sm font-bold font-display transition">{c.label}</TabsTrigger>
                            ))}
                        </TabsList>
                    </Tabs>
                    {visible.length === 0 ? (
                        <p className="mt-10 text-muted-foreground">No hay atracciones en esta categoría.</p>
                    ) : (
                        <motion.div initial="hidden" animate="show" variants={stagger} className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3" key={cat}>
                            {visible.map((it) => <AttractionCard key={it.id} item={it} />)}
                        </motion.div>
                    )}
                </div>
            </section>
        </PublicLayout>
    );
}
